import { useState, useContext } from 'react';
import { AppContext } from '../../../contexts/AppContext';
import { EndPoints } from '../EndPoints';
import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { WarehouseQuoteDetailDataForm, WarehouseQuoteDetailFilters } from '../../models/WareHouseQuoteDetail';

const useWarehouseQuoteDetailService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();
    const { showLoading, hideLoading } = useContext(AppContext);

    const [fetchingStoreWarehouseQuoteDetail, setFetchingStoreWarehouseQuoteDetail] = useState(false);
    const [fetchingUpdateWarehouseQuoteDetail, setFetchingUpdateWarehouseQuoteDetail] = useState(false);
    const [fetchingDeleteWarehouseQuoteDetail, setFetchingDeleteWarehouseQuoteDetail] = useState(false);
    const [fetchingShowWarehouseQuoteDetail, setFetchingShowWarehouseQuoteDetail] = useState(false);
    const [fetchingGetWarehouseQuoteDetails, setFetchingGetWarehouseQuoteDetails] = useState(false);
    const [fetchingCreateWarehouseQuoteDetails, setFetchingCreateWarehouseQuoteDetails] = useState(false);
    const [fetchingShowStorageDataWareHouseQuoteDetail, SetFetchingShowStorageDataWareHouseQuoteDetail] = useState(false);

    const getAllWarehouseQuoteDetailsByQuote = (
        quoteId: number,
        WarehouseQuoteDetailFilters: WarehouseQuoteDetailFilters,
        events: ServiceEvents = {}
    ) => {

        const queryString = Object.entries(WarehouseQuoteDetailFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.WAREHOUSE_QUOTES.GET_WAREHOUSE_QUOTE_DETAILS_BY_REQUEST}?${queryString}`;
        doGet({
            ...events,
            url: url.replace(
                ':quote_id',
                quoteId.toString()
            ),
            setFetching: setFetchingGetWarehouseQuoteDetails
        });
    };
    //     const showWarehouseQuoteDetail = (id: number, events: ServiceEvents = {}) => {
    //     doGet({
    //         ...events,
    //         url: EndPoints.WAREHOUSE_QUOTES.GET_WAREHOUSE_QUOTE_DETAIL.replace(':id', id.toString()),
    //         setFetching: setFetchingShowWarehouseQuoteDetail
    //     });
    // };

    const storeWarehouseQuoteDetail = (
        id: number,
        form: WarehouseQuoteDetailDataForm,
        events: ServiceEvents = {}
    ) => {
        doPost({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.STORE_WAREHOUSE_QUOTE_DETAIL,
            body: form,
            setFetching: setFetchingStoreWarehouseQuoteDetail
        });
    };

    const updateWarehouseQuoteDetail = (
        id: number,
        form: WarehouseQuoteDetailDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.UPDATE_WAREHOUSE_QUOTE_DETAIL.replace(':id', id.toString()),
            body: form,
            setFetching: setFetchingUpdateWarehouseQuoteDetail
        });
    };

    const deleteWarehouseQuoteDetail = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.DELETE_WAREHOUSE_QUOTE_DETAIL.replace(':id', id.toString()),
            setFetching: setFetchingDeleteWarehouseQuoteDetail
        });
    };


    const createWarehouseQuoteDetail = ( sectorId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.CREATE_WAREHOUSE_QUOTE_DETAIL.replace(':sector_id', sectorId.toString()),
            setFetching: setFetchingCreateWarehouseQuoteDetails
        });
    };
    const showWarehouseQuoteDetail = ( id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.SHOW_WAREHOUSE_QUOTE_DETAIL.replace(':id', id.toString()),
            setFetching: setFetchingCreateWarehouseQuoteDetails
        });
    };
    const editWarehouseQuoteDetail = ( id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.EDIT_WAREHOUSE_QUOTE_DETAIL.replace(':id', id.toString()),
            setFetching: setFetchingCreateWarehouseQuoteDetails
        });
    };


    const showStorageDataToWareHouseQuoteDetail = (
        quote_id: number,
        depot_id: number,
        product_id: number,
        events: ServiceEvents = {}
        ) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.GET_WAREHOUSE_QUOTE_DATA_BY_REQUEST
            .replace(':quote_id', quote_id.toString())
            .replace(':depot_id', depot_id.toString())
            .replace(':product_id', product_id.toString()),
            setFetching: SetFetchingShowStorageDataWareHouseQuoteDetail,
        });

    };

    return {
        showWarehouseQuoteDetail,
        storeWarehouseQuoteDetail,
        updateWarehouseQuoteDetail,
        deleteWarehouseQuoteDetail,
        getAllWarehouseQuoteDetailsByQuote,
        createWarehouseQuoteDetail,
        editWarehouseQuoteDetail,
        // showWarehouseQuoteDetail,
        showStorageDataToWareHouseQuoteDetail,
        fetchingShowWarehouseQuoteDetail,
        fetchingStoreWarehouseQuoteDetail,
        fetchingUpdateWarehouseQuoteDetail,
        fetchingDeleteWarehouseQuoteDetail,
        fetchingGetWarehouseQuoteDetails,
        fetchingCreateWarehouseQuoteDetails,
        fetchingShowStorageDataWareHouseQuoteDetail,
    };
};

export default useWarehouseQuoteDetailService;
